// AI-ASSISTED: generated with claude-code on 2026-06-10, reviewed by Yoann Hertienne
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { useEntity } from '@backstage/plugin-catalog-react';
import { TileBoundary } from '../team-landing/TileBoundary';

const ROVO_ANNOTATION = 'rovo.atlassian.com/query';
// Atlassian universal search (Rovo-powered) — works on every site,
// `/rovo/search` isn't a real endpoint and 404s. The `text=` query
// param pre-fills the search; Rovo summarizes results inline.
const SEARCH_BASE = 'https://luminus.atlassian.net/wiki/search';

const buildUrl = (query: string) =>
  `${SEARCH_BASE}?text=${encodeURIComponent(query)}`;

const RovoCardBody = () => {
  const { entity } = useEntity();
  const query = entity.metadata.annotations?.[ROVO_ANNOTATION];
  if (!query) return null;
  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="h6">Rovo</Typography>
        <Typography variant="body2" color="text.secondary">
          Search this component in Atlassian Rovo.
        </Typography>
      </CardContent>
      <CardActions>
        <Button
          variant="outlined"
          size="small"
          href={buildUrl(query)}
          target="_blank"
          rel="noreferrer"
          aria-label="Open Rovo search for this component"
        >
          Open in Rovo
        </Button>
      </CardActions>
    </Card>
  );
};

export const RovoCard = () => (
  <TileBoundary tool="Rovo">
    <RovoCardBody />
  </TileBoundary>
);
